import { isUndefined } from "lodash";
import { useEffect, useState } from "react";
import Loading from "shared/components/Spin";
import { COLORS } from "shared/style/colors";
import View from "./View";

const ProductsStats = ({ data, title }) => {
  const [productsData, setProductsData] = useState();

  useEffect(() => {
    constructChart(data);
  }, [data.length]);

  const constructChart = (chartData) => {
    const categories = chartData?.map(({ name }) => name);
    const dataPoints = chartData?.map(({ count }) => count);

    setProductsData({
      options: {
        title: {
          text: title,
          align: "left",
          style: {
            fontSize: "18px",
            fontWeight: "bold",
            color: COLORS.C_TEXT,
          },
        },
        chart: {
          id: `basic-bar`,
          background: COLORS.C_WHITE,
        },
        xaxis: {
          categories,
        },
        dataLabels: {
          enabled: true,
          style: {
            colors: [COLORS.C_WHITE],
          },
          offsetY: -20,
          dropShadow: {
            enabled: true,
          },
        },
      },
      series: [
        {
          name: title,
          data: dataPoints,
        },
      ],
    });
  };
  if (isUndefined(productsData)) return <Loading />;

  return <View data={productsData} />;
};

export default ProductsStats;
